import { ReactNode } from 'react';

import styled from 'styled-components';

import { pxToRem } from '../../utils/converters';
import { Button } from '../button';
import type { IconProps } from '../icons/base';
import { IconParrot } from '../icons/parrot';
import { Stack } from '../stack';
import { Text } from '../text';

export interface ErrorScreenAction {
  label: string;
  onClick: () => void;
  icon?: React.ReactElement<IconProps>;
}

export interface ErrorScreenProps {
  message: React.ReactNode;
  heading: string;
  flipped?: boolean;
  code?: number;
  actions?: ErrorScreenAction[];
  children?: ReactNode;
}

export const ErrorScreen = (props: ErrorScreenProps) => {
  const { code, message, heading, flipped = false, actions, children } = props;

  return (
    <>
      <ParrotContainer $flipped={flipped}>
        <IconParrot />
      </ParrotContainer>
      <ContentContainer>
        <Content>
          <Stack space={3}>
            {code && <Text font="yuge" color="orange100" text={String(code)} />}
            <Text font="heading1" color="elementPurpleInvert" text={heading} />
            <Text font="regular16" color="elementPurple80" text={message} />
            {actions && actions.length > 0 && (
              <Stack orientation="horizontal" space={4} justify="center">
                {actions.map((action, index) => (
                  <Button
                    key={index}
                    variant="secondary"
                    onClick={action.onClick}
                    iconLeft={action.icon}
                    text={action.label}
                  />
                ))}
              </Stack>
            )}
            {children}
          </Stack>
        </Content>
      </ContentContainer>
    </>
  );
};

const ParrotContainer = styled.div<{ $flipped: boolean }>((p) => ({
  position: 'absolute',
  left: 0,
  ...(p.$flipped
    ? {
        top: 0,
        transform: 'rotate(180deg) scaleX(-1)',
      }
    : {
        bottom: 0,
      }),
}));

const ContentContainer = styled.div({
  position: 'absolute',
  left: 0,
  bottom: 0,
  top: 0,
  right: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});

const Content = styled.div({
  textAlign: 'center',
  width: pxToRem(448),
});
